import { render } from "./teste.vue?vue&type=template&id=adb05172"
import script from "./teste.vue?vue&type=script&lang=js"
export * from "./teste.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__